import html2canvas from 'html2canvas';

export const generatePreview = preview => html2canvas(preview);
